import React, { useEffect } from "react";
import { Menu } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenu } from "../features/menu/menuSlice";
import resellerSvg from "../assets/svg/resellerSvg.svg";
import usersSvg from "../assets/svg/usersSvg.svg";
import airtimeSvg from "../assets/svg/airtimeSvg.svg";
import accountSvg from "../assets/svg/accountSvg.svg";
import requestSvg from "../assets/svg/requestSvg.svg";
import gridSvg from "../assets/svg/grid.svg";
import smsSvg from "../assets/svg/smsSvg.svg";
import creditSvg from "../assets/svg/creditSvg.svg";
import adminAccountSvg from "../assets/svg/adminAccountSvg.svg";
import externalSvg from "../assets/svg/externalSvg.svg";
import passwordSvg from "../assets/svg/passwordSvg.svg";
import withdrawalSvg from "../assets/svg/withdrawalSvg.svg";
import { useNavigate } from "react-router-dom";
import SidebarBrand from "./SidebarBrand";

const icons = {
  gridSvg,
  smsSvg,
  resellerSvg,
  usersSvg,
  airtimeSvg,
  accountSvg,
  requestSvg,
  passwordSvg,
  creditSvg,
  adminAccountSvg,
  externalSvg,
  withdrawalSvg,
};

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export default function SideBarClosed() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const { menuData } = useSelector((state) => state.menu);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateMenuItems = (currentMenuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }

    const mapItems = (items, isChild) =>
      items?.map((item) => {
        const iconSrc = icons[item?.mnIcons] || gridSvg;
        return getItem(
          item?.mnName.charAt(0).toUpperCase() + item?.mnName.slice(1),
          item?.mnLink,
          !isChild ? (
            <img src={iconSrc} alt={item?.mnIcons} />
          ) : (
            <span className="weiser-sidebar-child-icon" aria-hidden="true">
              <SendOutlined />
            </span>
          ),
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });

    if (!currentMenuData || currentMenuData?.length === 0) {
      return [];
    }

    return mapItems(currentMenuData);
  };

  const items = [
    ...generateMenuItems(menuData),
    {
      type: "divider",
    },
  ];

  const handleNavigation = async (e) => {
    await navigate(e?.key);
  };

  useEffect(() => {
    dispatch(fetchMenu());
  }, []);

  return (
    <div className="weiser-sidebar-shell weiser-desktop-sidebar weiser-sidebar-closed flex flex-col h-full">
      <SidebarBrand collapsed />
      <div className="weiser-sidebar-scroll weiser-soft-scrollbar">
        <Menu
          onClick={handleNavigation}
          defaultSelectedKeys={["dash", "/dashboard"]}
          defaultOpenKeys={[]}
          mode="inline"
          theme="light"
          inlineCollapsed={sideMenuCollapsed}
          className="weiser-sidebar-menu"
          items={items}
        />
      </div>
    </div>
  );
}
